<div class="message-container d-flex no-wrap jc-start ai-start system-message" [ngClass]="options?.messageClass" role="log" aria-live="polite" #main>
  <div class="col-auto pl-0">
    <span *ngIf="options?.messageClass === 'warning'" class="icon icon-error color-warning"></span>
    <span *ngIf="options?.messageClass === 'error'" class="icon icon-critical color-error"></span>
    <span *ngIf="options?.messageClass === 'success'" class="icon icon-sucess color-success"></span>
  </div>
  <div class="col fs-md break-word">
    <p class="medium m-0 mb-h">{{title}}</p>
    <p class="m-0" [innerHTML]="message"></p>
  </div>
  <div class="col-auto pr-0" *ngIf="options?.closeButton">
    <button class="reset-button link-secondary p-0" type="button"
            data-test-id="button_close_system_message" (click)="remove()">
      <span class="icon icon-close"></span>
    </button>
  </div>
  <div *ngIf="options.progressBar">
    <div class="toast-progress" [style.width]="width + '%'"></div>
  </div>
</div>
